import { CachedDropdownsState } from './partials/cached-dropdowns'
import { RouteSharedState } from './partials/route'
import { SharedSettingsState } from './partials/settings'
import { TmetricSharedState } from './partials/tmetric'
import { WorkflowSharedState } from './partials/workflow'

export const SharedState = _ => ({
  ...CachedDropdownsState,
  ...RouteSharedState,
  ...SharedSettingsState,
  ...TmetricSharedState,
  ...WorkflowSharedState,
})
